const useMethodPayment = () => {
  const getMethodPayment = (isCod, amountCOD) => {
    if (!isCod) {
      return "پیشکرایه";
    }

    if (amountCOD === 0) {
      return "پسکرایه";
    }

    return "پرداخت در محل-COD";
  };

  return { getMethodPayment };
};

export default useMethodPayment;
